export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
export const REQUEST_PATH = '/request_view'
export const CHAT_PATH = '/chat_view'
